import { Component, ViewChild, OnDestroy } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular/ui/popup';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { PopupService } from '../../services/popup.service';
import { lastValueFrom, Subscription } from 'rxjs';
import { ConfigService } from '../../services/config.service';
import { Router } from '@angular/router';
import { DxDataGridComponent, DxFormComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-periodenEditPopup',
  templateUrl: './periodenEditPopup.component.html',
  styleUrls: ['./periodenEditPopup.component.scss'],
  standalone: false,
})
export class PeriodenEditPopupComponent implements OnDestroy {
  @ViewChild('popup', { static: false }) popup: DxPopupComponent;
	@ViewChild('periodenForm', { static: false }) periodenForm: DxFormComponent;
  @ViewChild('periodenDataGrid', { static: false }) periodenDataGrid: DxDataGridComponent;
  

  onClose: (e) => void;
	betragArt: string;
	dataSource: any;
  subscription_get_PopupAsObservable: Subscription;
  isLoading: boolean = false;
  contextData: any;

  constructor(private apiService: ApiService, private popupService: PopupService, public configService: ConfigService, private router: Router) {
    this.onClickClose = this.onClickClose.bind(this);

    this.subscription_get_PopupAsObservable = this.popupService.get_periodeEditPopupAsObservable.subscribe((context) => {
      if (context !== null && context !== undefined && context.open === true) {
				this.betragArt = context.data;
        this.onClose = context.closeCb;
        this.popup.instance.show();
      } else {
				this.betragArt = '';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription_get_PopupAsObservable) {
      this.subscription_get_PopupAsObservable.unsubscribe();
    }
  }

	ngOnInit(): void {
			this.dataSource = new DataSource({
			key: 'id',
			load: (loadOptions) => {
				loadOptions.userData.Selector = this.betragArt;

				return lastValueFrom(this.apiService.post<any>(RouteKeys.Bgb.zeitraum_search, loadOptions))
				.then((response) => {
						return {
						data: response.data,
						};
				})
				.catch((err) => {
						throw err.message;
				});
			},
      insert: (values) => {
				return lastValueFrom(this.apiService.post<any>(RouteKeys.Bgb.zeitraum_set, { beitragsArt: this.betragArt, ...values }))
					.then(() => {})
					.catch((err) => {
						notify({ message: err.message }, 'error');
						throw err.message;
					});
      },
      update: (id, values) => {
        return lastValueFrom(this.apiService.post<any>(RouteKeys.Bgb.zeitraum_set, { id: id, ...values }))
          .then(() => {})
          .catch((err) => {
            notify({ message: err.message }, 'error');
            throw err.message;
          });
      },
      remove: (_id) => {
        return lastValueFrom(this.apiService.post<any>(RouteKeys.Bgb.zeitraum_delete, { id: _id }))
          .then(() => {})
          .catch((err) => {
            notify({ message: 'Der Zeitraum kann nicht gelöscht werden: ' + err.message }, 'error', 6000);
            throw err.message;
          });
      },			
		});
	}

  onClickClose(e) {
    if (this.onClose !== undefined && this.onClose !== null) {
      this.onClose(3);
    }
    this.popup.instance.hide();
  }

  getBetragsArtText() {
		switch (this.betragArt) {
			case 'EB':
				return 'zu Elternbeitrag'
			case 'EG':
				return 'zu Essengeld'
			case 'FB':
				return 'zu Ferienbetreuung'
			default:
				return ''
		}
  }

  onToolbarPreparing(e) {
		// const toolbarItems = e.toolbarOptions.items;
    
    var addButton = e.toolbarOptions.items.filter((item) => item.name === 'addRowButton');
    if (addButton && addButton[0]) {
      addButton[0].showText = true;
      addButton[0].options = {text: 'Neuer Zeitraum',
      type: 'default',
      icon: 'add',
			onClick: (event) => this.periodenDataGrid.instance.addRow(),
      hint: 'Neuen Zeitraum hinzufügen',
      stylingMode: 'contained' };
    }
  }

  onRowDblClick(e) {
		e.component.editRow(e.rowIndex);
  }

	onRowUpdating(e) {
    const updatedData = {
        ...e.oldData,
        ...e.newData
    };

    e.newData = updatedData;
	}

	onEditorPreparing(e) {
    if (e.parentType !== 'dataRow') return;

    if (e.dataField === 'von' || e.dataField === 'bis') {
        const originalHandler = e.editorOptions.onValueChanged;

        e.editorOptions.onValueChanged = (args: any) => {
            if (originalHandler) {
                originalHandler(args);
            }
						
            const formData = e.row.data;

            const von = formData.von;
            const bis = formData.bis;
            const name = formData.name;

            if (!name && von && bis) {
                const von_bis = formatDate(formData.von, 'dd.MM.yyyy', 'DE') + ' - ' + formatDate(formData.bis, 'dd.MM.yyyy', 'DE');
                e.component.cellValue(e.row.rowIndex, 'name', von_bis);
            }
        };
    }		
	}

	validateDates = (e: any) => {
    const data = e.data;
    const von = data.von;
    const bis = data.bis;

    if (!von || !bis) {
        return true;
    }
    return new Date(von) <= new Date(bis);
	};
}
